export const ENIGMA_MAX_DIGITS = 4;